// 恢复账号提示界面 1

require("clover/panel/component/common/UIGroupButton")
require("clover/panel/base/BasePanel")

let AccountRecoveryTipPanel = xClass("AccountRecoveryTipPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack",
    "font/zzgftongxin_40.png",
    "font/zzgftongxin_40.fnt",
    // "packed/SeasideStarRankPanel.pack"
)
AccountRecoveryTipPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountRecoveryTipPanel.preloadResPromise = function(useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountRecoveryTipPanel.getInstance = function () {
    let self = this
    return _instance
}
AccountRecoveryTipPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self

    self.data = data || {}
    self.aManager = AccountManager.getInstance()
    self.aManager.dcRecoveryTipPanelOpen(self.data.id)

    self.initUI();
}
AccountRecoveryTipPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountRecoveryTipPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}


AccountRecoveryTipPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_disable.csb")
    // self.mainNode = cc.CSLoader.createNode("cocos/seasidestar_rank.csb")
    self.addChild(self.mainNode);

    self.mainNode.getChildByName("lable1").setVisible(false)
    self.mainNode.getChildByName("lable2").setVisible(false)
    this.btnClose = self.mainNode.getChildByName("close");
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (window.mini){
            mini.exitMiniProgram({})
        }
    }, true);

    this.btnRelogin = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnRelogin, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        self.aManager.dcRecoveryTipPanelClick()
        if(self.data.reloginCb){
            self.data.reloginCb()
        }
    }, true);
    this.mainNode.getChildByName("tittle_lab").setString("账号已停用")

    this.btnRelogin.getChildByName("txt").setString("恢复账号")

    let txtString = "您的消消乐账号：{id}\n    该账号处于停用状态，将于{c=155,91,63,255/c}{date}{c=215,42,31,255/c}正式删除，如您为误操作删除账号，请点击【恢复账号】重新进入游戏。{c=155,91,63,255/c}"
    // let txtString = getText("delete.page6.text")

    txtString = txtString.replace("{id}",  self.data.id);
    let localDate =  new Date(self.data.delTime)//new Date()
    let dateStr= formatDate(localDate, 'yyyy年MM月dd日HH时mm分ss秒')
    txtString = txtString.replace("{date}", dateStr);

    let colorLabel= getColorTextH5(txtString,21,22)
    colorLabel.x = -colorLabel.width/2
    colorLabel.y = 90

    // colorLabel.x = -110
    this.mainNode.addChild(colorLabel)
    
}


AccountRecoveryTipPanel.prototype.popup = function () {
    let self = this
    let size = cc.Director.getInstance().getVisibleSize()
	self.setPosition(size.width / 2, size.height / 2)

    //popup动画
    let actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        self.mainNode.setScale(0.1)
    }))
    table.insert(actionList, cc.EaseSineOut.create(cc.ScaleTo.create(0.2, 1)))
    self.mainNode.runAction(cc.Sequence.create(actionList))

    var curScene = cc.Director.getInstance().getRunningScene()
	curScene.addChild(self)
	return self

}
module.exports = AccountRecoveryTipPanel